import { Form as UnstyledForm } from '@sketch/components'
import styled from 'styled-components'

export const ContentContainer = styled.div`
  padding: 24px 0;
`

export const Form = styled(UnstyledForm)`
  display: grid;
  gap: 16px;
`

export const InlineFormRow = styled.div`
  display: flex;
  gap: 20px;

  ${UnstyledForm.Field} {
    width: 100%;
  }
`

export const Separator = styled.hr`
  height: 1px;
  background-color: ${({ theme }) => theme.colors.border.B};
  margin: 0 -32px 0 -32px;
`
